import api from "./api";

export const projectList = async (loggedInUserTypeId,userTypeId=null) => {
  try {
    const response = await api.get(`Projects?userTypeId=${userTypeId}&loggedInUserTypeId=${loggedInUserTypeId}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const projectById = async (loggedInUserTypeId,id) => {
  try {
    const response = await api.get(`/Projects/${id}?loggedInUserTypeId=${loggedInUserTypeId}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const toggleProjectStatus = async (loggedInUserTypeId,id, flag) => {
  try {
    const response = await api.put(`/Projects/status/${id}?isActive=${flag}&loggedInUserTypeId=${loggedInUserTypeId}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const addProjectDetails = async (loggedInUserTypeId,form) => {
  try {
    const response = await api.post(`/Projects?loggedInUserTypeId=${loggedInUserTypeId}`, form, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error editing project:", error);
    throw error; // This rethrows the error to propagate to getProjectById's catch block
  }
};

export const editProjectDetails = async (loggedInUserTypeId,form, id) => {
  try {
    const response = await api.put(`/Projects/${id}?loggedInUserTypeId=${loggedInUserTypeId}`, form, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error editing project:", error);
    throw error; 
  }
};
export const deleteProjectDetails = async (loggedInUserTypeId,id) => {
  try {
    const response = await api.delete(`/Projects/${id}?loggedInUserTypeId=${loggedInUserTypeId}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};
